import type { CampaignStatus } from '../types/campaign';

/**
 * Status Transition Service
 *
 * NOTE: Campaign status is now automatically calculated by the database trigger.
 * This service only provides UI helpers for display and row styling.
 *
 * The monotonic status logic lives in:
 * /supabase/migrations/20251103000002_monotonic_status_function.sql
 */

export const statusTransitionService = {
  /**
   * Get visual styling class for campaign status rows
   * Used in TableView to highlight campaigns by their status
   */
  getStageRowClass(status: CampaignStatus): string {
    switch (status) {
      case 'Consultation':
        return 'border-l-4 border-l-gray-200 bg-gray-50/30';
      case 'Confirmed':
        return 'border-l-4 border-l-sky-300 bg-sky-50/30';
      case 'In Progress':
        return 'border-l-4 border-l-blue-300 bg-blue-50/30';
      case 'Billing':
        return 'border-l-4 border-l-amber-300 bg-amber-50/30';
      case 'Completed':
        return 'border-l-4 border-l-green-300 bg-green-50/30';
      default:
        return '';
    }
  }
};
